import React from 'react';

const ScoringAlgorithmVisual = ({ className }) => (
    <img
        src={process.env.PUBLIC_URL + '/assets/features/scoring-algorithm-visual.svg'}
        alt="Expert-Built Content"
        className={className}
    />
);

export default ScoringAlgorithmVisual;
